export default "__VITE_ASSET__QNcUCTD2__"